<template>
	<div class="record_list_item bg-white" @click="$emit('click')">
		<div class="header">
			<template v-if="type == 1">
				<img src="../../../assets/icon/video.png" />
				<div style="flex:1">视频咨询</div>
			</template>
			<template v-else>
				<img src="../../../assets/icon/audio.png" />
				<div style="flex:1">语音咨询</div>
			</template>
			<p class="status" :class="getStatusClass">{{ $status.consultOrderStatus[status] }}</p>
		</div>
		<div class="main ">
			<img src="../../../assets/img/bg-02.png" />
			<div class="content">
				<p class="doctor">
					<span class="name">{{ name }}</span>
					<span class="line">|</span>
					<span class="department">{{title}}</span>
				</p>
				<p class="hospital">{{hospital}}</p>
			</div>
		</div>
		<div class="footer">
			<p class="time">{{createTime}}</p>
			<van-button v-if="status == 1" class="footer_btn" type="primary" size="small" @click.stop="$emit('pay')">
				支付
			</van-button>
			<van-button v-else class="footer_btn" type="primary" size="small" @click.stop="$emit('preview')">
				查看
			</van-button>
		</div>
	</div>
</template>

<script>
export default {
    name: 'ChatListItem',
    props: {
        title: {
            type: String,
            default: ''
        },
        status: {
            type: [String, Number],
            default: ''
        },
        type: {
            type: [String, Number],
            default: ''
        },
        createTime: {
            type: String,
            default: ''
        },
        price: {
            type: [String, Number],
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        hospital: {
            type: String,
            default: ''
        }
    },
    computed: {
        getStatusClass () {
            return {
                1: 'danger',
                2: 'success',
                3: 'normal'
            }[this.status]
        }
    }
};
</script>

<style scoped lang="less">
.record_list_item {
	border-radius: 16px;
	padding: 0 28px;
	.header {
		padding: 32px 0 28px 0;
		display: flex;
		align-items: center;
		font-size: 28px;
		color: #1f2329;
		border-bottom: 1px solid #eff0f1;
		img {
			width: 38px;
			height: 38px;
			margin-right: 16px;
		}
		.status {
			text-align: right;
			flex: 0 0 100px;
			font-family: PingFangSC-Regular;
			font-size: 26px;
			font-weight: normal;
			&.danger {
				color: @danger;
			}
			&.normal {
				color: #bbbfc4;
			}
			&.success {
				color: @primary;
			}
		}
	}
	.main {
		padding: 28px 0;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #eff0f1;
		img {
			width: 88px;
			height: 88px;
			border-radius: 16px;
			margin-right: 20px;
		}
		.content {
			flex: 1;
			.doctor {
				color: #1f2329;
				font-size: 34px;
				vertical-align: text-bottom;
				.name {
					font-weight: bold;
				}
				.line {
					color: #ececec;
					font-size: 26px;
					margin: 0 16px;
				}
				.department {
					color: #000000;
					font-size: 28px;
				}
			}
			.hospital {
				margin-top: 16px;
				font-size: 26px;
				color: @gray-9;
			}
		}
	}
	.footer {
		padding: 28px 0 32px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.time {
			font-family: PingFangSC-Regular;
			font-size: 24px;
			font-weight: normal;
			color: #8f959e;
		}
		.footer_btn {
			width: 150px;
			height: 60px;
			line-height: 60px;
			border-radius: 12px;
			font-family: PingFangSC-Medium;
		}
	}
}
</style>
